import { render, staticRenderFns } from "./gtr-modal.vue?vue&type=template&id=7fdc63ba"
import script from "./gtr-modal.vue?vue&type=script&lang=ts"
export * from "./gtr-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports